import Podgrupe from "../components/Podgrupe/Podgrupe";
import Navigacija from "../components/Navigacija/Navigacija";
import Roba from "../components/Roba/Roba";
import GrupaRoba from "../components/GrupaRoba/GrupaRoba";
export default function MiniKalkulator(){

    return(
        <>
            <Navigacija />
            <Podgrupe />
            <Roba />

        </>
    )
}
